const stripe = window.Stripe(process.env.REACT_APP_STRIPE_KEY);

export default stripe;
